import {
  ACCESS_PERMISSION_ADMIN,
  ACCESS_PERMISSION_READ,
  ACCESS_PERMISSION_WRITE,
  deniedReason,
} from '@/utils/accessPermission';

/**
 * The bit the backend checks on the item itself for each vault row action.
 * A move also needs WRITE on the target folder, and change owner of anything
 * but a single file is org admins only; the backend refuses those as it goes.
 */
const VAULT_ACTION_BIT: Partial<Record<string, number>> = {
  'open-folder': ACCESS_PERMISSION_READ,
  preview: ACCESS_PERMISSION_READ,
  unpack: ACCESS_PERMISSION_READ,
  download: ACCESS_PERMISSION_READ,
  'download-folder': ACCESS_PERMISSION_READ,
  versions: ACCESS_PERMISSION_READ,
  'ask-ai': ACCESS_PERMISSION_READ,
  'insert-into-word': ACCESS_PERMISSION_READ,
  'export-to-gaia': ACCESS_PERMISSION_READ,
  rename: ACCESS_PERMISSION_WRITE,
  sign: ACCESS_PERMISSION_WRITE,
  'convert-to-docx': ACCESS_PERMISSION_WRITE,
  'add-file': ACCESS_PERMISSION_WRITE,
  move: ACCESS_PERMISSION_ADMIN,
  delete: ACCESS_PERMISSION_ADMIN,
  share: ACCESS_PERMISSION_ADMIN,
  'change-owner': ACCESS_PERMISSION_ADMIN,
  'convert-to-contract': ACCESS_PERMISSION_ADMIN,
};

interface WithPermissions {
  permissions?: number | null;
}

/** Why the caller's bits on `item` rule out `action`; null when they allow it. */
export function vaultActionBlock(item: WithPermissions, action: string): string | null {
  const bit = VAULT_ACTION_BIT[action];
  return bit === undefined ? null : deniedReason(item.permissions, bit);
}

/** A bulk action needs the bit on every selected item. */
export function vaultBulkActionBlock(items: WithPermissions[], action: string): string | null {
  for (const item of items) {
    const reason = vaultActionBlock(item, action);
    if (reason) return items.length > 1 ? `${reason} on every selected item` : reason;
  }
  return null;
}
